export const environment = {
  production: false,
  apiBaseUrl: 'https://develop.celeri.today/api/v1',
  environmentName: 'development'
};
